/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Code_LabelInputs */



/**
* | output |
* | --- |
* | "Share code" |
*
* @param {Team_Share_Code_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_code_label = /** @type {((inputs?: Team_Share_Code_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Code_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Share code")
	if (locale === "de") return /** @type {LocalizedString} */ ("Share code")
	if (locale === "it") return /** @type {LocalizedString} */ ("Share code")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Share code")
	if (locale === "es") return /** @type {LocalizedString} */ ("Share code")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Share code")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Share code")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Share code")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Share code")
	return /** @type {LocalizedString} */ ("Share code")
});